import React from 'react';

export default function SecondSection({ params }) {
  const { fullname, address, city, zipCode, phone, complement, information } = params;
  return (
    <>
      <p>
        <b>Client :</b> {fullname}
      </p>
      <p>
        <b>Adresse : </b>
        {address} - {city} {zipCode}
      </p>
      {phone && (
        <p>
          <b>Téléphone :</b> {phone}
        </p>
      )}
      {complement && (
        <p>
          <b>Complément : </b>
          <br />
          {complement}
        </p>
      )}
      {information && (
        <p>
          <b>Information : </b>
          <br />
          {information}
        </p>
      )}
    </>
  );
}
